import * as Sentry from '@sentry/react';

import { env } from '@/env';

import type { WebappEnv } from '../entities/webapp-env';

export function initSentry(environment: WebappEnv, release: string) {
  Sentry.init({
    dsn: 'https://5fe03bfc536755d20a3e2ab1fc5dda70@o4507175956381696.ingest.de.sentry.io/4508834477834320',
    environment,
    release,
    enabled: env.VITE_SENTRY_ENABLE,

    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.zodErrorsIntegration({}),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        mask: ['input[type="password"]', '[data-sentry-mask]'],
      }),
      Sentry.httpClientIntegration({
        failedRequestTargets: [
          'https://*.accurecloud.io',
          'https://*.accure-platform.com',
        ],
      }),
    ],

    ignoreErrors: [
      /Login required/,
      /Timeout when executing 'fetch'/,
      /The operation was aborted/,
    ],

    beforeSend(event) {
      const isAuthNoise = event.exception?.values?.some(
        (e) =>
          e.type === 'UnauthorizedError' || e.value?.includes('Expired token'),
      );
      if (isAuthNoise) return null;
      return event;
    },

    tracePropagationTargets: [
      /^https:\/\/.*\.accure-platform\.com/,
      /^https:\/\/.*\.accurecloud\.io/,
    ],
  });
}
